import { render, staticRenderFns } from "./3d-modal.vue?vue&type=template&id=b5fd1f80&scoped=true&"
import script from "./3d-modal.vue?vue&type=script&lang=js&"
export * from "./3d-modal.vue?vue&type=script&lang=js&"
import style0 from "./3d-modal.vue?vue&type=style&index=0&id=b5fd1f80&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b5fd1f80",
  null
  
)

export default component.exports